/**
 * The DOMPurify allow-list for email bodies is now owned by `@west-tennessee-consulting/email/sanitize`
 * (single source shared with the WTC mail client). Re-exported here so existing
 * `body-utils` imports keep working.
 */
export { EMAIL_BODY_DOM_PURIFY_CONFIG } from "@west-tennessee-consulting/email/sanitize";

export const EMAIL_BODY_PROSE_CLASSES =
  "prose max-w-none text-sm leading-relaxed [&_*]:max-w-none [&_img]:max-w-full [&_img]:h-auto [&_a]:break-words [&_a]:text-blue-600 [&_a]:underline [&_p]:mb-2 [&_div]:mb-2 [&_table]:w-full [&_table]:border-collapse [&_td]:border [&_td]:p-2 [&_th]:border [&_th]:p-2 [&_th]:bg-muted/40";
